import React from 'react';
import logoHeader from '../assets/logo.png';
import SignInForm from '../components/SignInForm';

const SignInPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="w-full max-w-md p-8">
        <div className="flex justify-center mb-[60px]">
          <img 
            src={logoHeader} 
            alt="Header Logo" 
            className="h-[75px] w-[115px]"
          />
        </div>
        <SignInForm />
      </div>
    </div>
  );
};

export default SignInPage;